export default __webpack_public_path__ + "static/media/logoEmail.52868464.svg";